import gsap from "gsap";

const trailer = document.querySelector(".image-trailer");
const imageSources = [
  "/shared/images/7.jpg",
  "/shared/images/8.jpg",
  "/shared/images/9.jpg",
  "/shared/images/10.jpg",
  "/shared/images/11.jpg",
  "/shared/images/12.jpg",
];
const preloadedImages = imageSources.map((source) => {
  const image = new Image();
  image.src = source;
  return image;
});

let currentImageIndex = 0;
let lastSpawnPosition = null;
let lastImageTime = 0;
let pointerPosition = null;
let frameRequested = false;

const movementThreshold = 55;
const delayBetween = 50;

function createImageTrail({ x, y }, now) {
  const distance = lastSpawnPosition
    ? Math.hypot(x - lastSpawnPosition.x, y - lastSpawnPosition.y)
    : movementThreshold;

  if (now - lastImageTime < delayBetween) return;
  if (distance < movementThreshold) return;

  const image = document.createElement("img");
  image.className = "image-item";
  image.src = preloadedImages[currentImageIndex].src;
  image.alt = "";
  image.decoding = "async";
  image.style.left = `${x}px`;
  image.style.top = `${y}px`;

  currentImageIndex = (currentImageIndex + 1) % imageSources.length;
  lastSpawnPosition = { x, y };
  lastImageTime = now;

  trailer.appendChild(image);
  gsap
    .timeline({ onComplete: () => image.remove() })
    .fromTo(
      image,
      {
        scale: 0,
        rotation: gsap.utils.random(-10, 10),
      },
      {
        scale: 1,
        duration: 0.35,
        ease: "power3.out",
      },
    )
    .to(image, {
      scale: 0,
      duration: 0.35,
      delay: 0.25,
      ease: "power2.in",
    });
}

function handlePointerMove(event) {
  pointerPosition = { x: event.clientX, y: event.clientY };

  if (frameRequested) return;
  frameRequested = true;

  requestAnimationFrame((timestamp) => {
    frameRequested = false;
    createImageTrail(pointerPosition, timestamp);
  });
}

document.addEventListener("pointermove", handlePointerMove, { passive: true });
